/**
 * Функция возращает значение куки по ключу
 * @param {string} name - ключ для куки
 * @returns {string|undefined}
 */
export var getCookie = function getCookie(name) {
  if (typeof document === 'undefined') return undefined;
  var matches = document.cookie.match(new RegExp("(?:^|; )".concat(name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1'), "=([^;]*)")));
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

/**
 * Функция ставит куку
 * @param {string} name - Имя куки
 * @param {string|number} [value=''] - Значение куки
 * @param {string} [domain] - Домен, на котором доступна кука
 * @param {number} [ttl] - Дата истечения срока действия куки
 * @param {string} [path='/'] - path url
 * @param {string|number} [maxAge] - Время жизни куки в секундах
 */
export var setCookie = function setCookie(_ref) {
  var name = _ref.name,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    domain = _ref.domain,
    ttl = _ref.ttl,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/' : _ref$path,
    maxAge = _ref.maxAge;
  // eslint-disable-next-line max-len
  document.cookie = "".concat(name, "=").concat(value).concat(domain ? ";domain=".concat(domain) : '').concat(path ? ";path=".concat(path) : '').concat(ttl ? ";expires=".concat(new Date(new Date().getTime() + ttl).toUTCString()) : '').concat(maxAge ? ";max-age=".concat(maxAge) : '');
};

/**
 * Функция удаляет куку по ключу
 * @param {string} name - ключ для куки
 */
export var deleteCookie = function deleteCookie(name) {
  setCookie({
    name: name,
    maxAge: -1
  });
};